declare namespace $ {

	type $mol_labeler__title_bog_gamengine_demo_flat_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__content_bog_gamengine_demo_flat_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_labeler['content'] >
	>
	type $mol_check_box__title_bog_gamengine_demo_flat_3 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_bog_gamengine_demo_flat_4 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['screen_shown'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $bog_gamengine_draw__scene_bog_gamengine_demo_flat_5 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Scene'] >
		,
		ReturnType< $bog_gamengine_draw['scene'] >
	>
	type $bog_gamengine_draw__cam_bog_gamengine_demo_flat_6 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Cam'] >
		,
		ReturnType< $bog_gamengine_draw['cam'] >
	>
	type $bog_gamengine_draw__event_bog_gamengine_demo_flat_7 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_gamengine_demo_flat['pointer_down'] > ): ReturnType< $bog_gamengine_demo_flat['pointer_down'] >,
		}) 
		,
		ReturnType< $bog_gamengine_draw['event'] >
	>
	type $mol_view__sub_bog_gamengine_demo_flat_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_gamengine_demo_flat_9 = $mol_type_enforce<
		({ 
			'left': ReturnType< $bog_gamengine_demo_flat['label_left'] >,
			'top': ReturnType< $bog_gamengine_demo_flat['label_top'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $bog_gamengine_input_screen__shown_bog_gamengine_demo_flat_10 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['screen_shown'] >
		,
		ReturnType< $bog_gamengine_input_screen['shown'] >
	>
	type $mol_view__sub_bog_gamengine_demo_flat_11 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_flat_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_flat_13 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_gamengine_demo_flat_14 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_gamengine_phys__bodies_bog_gamengine_demo_flat_15 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['bodies'] >
		,
		ReturnType< $bog_gamengine_phys['bodies'] >
	>
	type $bog_gamengine_phys__tile_bog_gamengine_demo_flat_16 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Tile'] >
		,
		ReturnType< $bog_gamengine_phys['tile'] >
	>
	type __bog_gamengine_demo_flat_17 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_flat['hero_face_left'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_flat['Hero'] >['face_left'] >[0]
	>
	type __bog_gamengine_demo_flat_18 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_flat['hero_clip'] >[0]
		,
		Parameters< ReturnType< $bog_gamengine_demo_flat['Hero'] >['clip'] >[0]
	>
	type __bog_gamengine_demo_flat_19 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_flat['coin_taken'] >[0]
		,
		Parameters< $bog_gamengine_demo_flat['Coin'] >[0]
	>
	type __bog_gamengine_demo_flat_20 = $mol_type_enforce<
		Parameters< $bog_gamengine_demo_flat['coin_taken'] >[1]
		,
		Parameters< $bog_gamengine_demo_flat['Coin'] >[0]
	>
	type $bog_gamengine_input__key_bog_gamengine_demo_flat_21 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Key'] >
		,
		ReturnType< $bog_gamengine_input['key'] >
	>
	type $bog_gamengine_input__screen_bog_gamengine_demo_flat_22 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Screen'] >
		,
		ReturnType< $bog_gamengine_input['screen'] >
	>
	type $bog_gamengine_key__bind_bog_gamengine_demo_flat_23 = $mol_type_enforce<
		({ 
			'left': readonly(any)[],
			'right': readonly(any)[],
			'up': readonly(any)[],
			'down': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_key['bind'] >
	>
	type $bog_gamengine_phys_tile__map_bog_gamengine_demo_flat_24 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['map'] >
		,
		ReturnType< $bog_gamengine_phys_tile['map'] >
	>
	type $bog_gamengine_atlas__uris_bog_gamengine_demo_flat_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $bog_gamengine_atlas['uris'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_flat_26 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_point__cam_bog_gamengine_demo_flat_27 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Cam'] >
		,
		ReturnType< $bog_gamengine_point['cam'] >
	>
	type $bog_gamengine_point__width_bog_gamengine_demo_flat_28 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['draw_width'] >
		,
		ReturnType< $bog_gamengine_point['width'] >
	>
	type $bog_gamengine_point__height_bog_gamengine_demo_flat_29 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['draw_height'] >
		,
		ReturnType< $bog_gamengine_point['height'] >
	>
	type $bog_gamengine_point__scale_bog_gamengine_demo_flat_30 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['draw_dpr'] >
		,
		ReturnType< $bog_gamengine_point['scale'] >
	>
	type $bog_gamengine_sound__uris_bog_gamengine_demo_flat_31 = $mol_type_enforce<
		({ 
			'coin': string,
		}) 
		,
		ReturnType< $bog_gamengine_sound['uris'] >
	>
	type $bog_gamengine_scene__clock_bog_gamengine_demo_flat_32 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Clock'] >
		,
		ReturnType< $bog_gamengine_scene['clock'] >
	>
	type $bog_gamengine_scene__input_bog_gamengine_demo_flat_33 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Input'] >
		,
		ReturnType< $bog_gamengine_scene['input'] >
	>
	type $bog_gamengine_scene__kids_bog_gamengine_demo_flat_34 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['nodes'] >
		,
		ReturnType< $bog_gamengine_scene['kids'] >
	>
	type $bog_gamengine_scene__phys_bog_gamengine_demo_flat_35 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Phys'] >
		,
		ReturnType< $bog_gamengine_scene['phys'] >
	>
	type $bog_gamengine_cam_flat__height_bog_gamengine_demo_flat_36 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_cam_flat['height'] >
	>
	type $bog_gamengine_cam_flat__pos_bog_gamengine_demo_flat_37 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['cam_pos'] >
		,
		ReturnType< $bog_gamengine_cam_flat['pos'] >
	>
	type $bog_gamengine_tilemap__tile_bog_gamengine_demo_flat_38 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Tile'] >
		,
		ReturnType< $bog_gamengine_tilemap['tile'] >
	>
	type $bog_gamengine_tilemap__atlas_bog_gamengine_demo_flat_39 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Atlas'] >
		,
		ReturnType< $bog_gamengine_tilemap['atlas'] >
	>
	type $bog_gamengine_tilemap__palette_bog_gamengine_demo_flat_40 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['palette'] >
		,
		ReturnType< $bog_gamengine_tilemap['palette'] >
	>
	type $bog_gamengine_demo_flat_hero__input_bog_gamengine_demo_flat_41 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Input'] >
		,
		ReturnType< $bog_gamengine_demo_flat_hero['input'] >
	>
	type $bog_gamengine_demo_flat_hero__pos_bog_gamengine_demo_flat_42 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['hero_pos'] >
		,
		ReturnType< $bog_gamengine_demo_flat_hero['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_flat_43 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Hero'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_flat_44 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_flat_45 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__flip_x_bog_gamengine_demo_flat_46 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['hero_face_left'] >
		,
		ReturnType< $bog_gamengine_sprite['flip_x'] >
	>
	type $bog_gamengine_sprite__clock_bog_gamengine_demo_flat_47 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Clock'] >
		,
		ReturnType< $bog_gamengine_sprite['clock'] >
	>
	type $bog_gamengine_sprite__clip_bog_gamengine_demo_flat_48 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['hero_clip'] >
		,
		ReturnType< $bog_gamengine_sprite['clip'] >
	>
	type $bog_gamengine_sprite__fps_bog_gamengine_demo_flat_49 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_sprite['fps'] >
	>
	type $bog_gamengine_sprite__clips_bog_gamengine_demo_flat_50 = $mol_type_enforce<
		({ 
			'walk': readonly(any)[],
		}) 
		,
		ReturnType< $bog_gamengine_sprite['clips'] >
	>
	type $bog_gamengine_nav_grid__tile_bog_gamengine_demo_flat_51 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Tile'] >
		,
		ReturnType< $bog_gamengine_nav_grid['tile'] >
	>
	type $bog_gamengine_nav_agent__grid_bog_gamengine_demo_flat_52 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Grid'] >
		,
		ReturnType< $bog_gamengine_nav_agent['grid'] >
	>
	type $bog_gamengine_nav_agent__target_bog_gamengine_demo_flat_53 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['hero_pos'] >
		,
		ReturnType< $bog_gamengine_nav_agent['target'] >
	>
	type $bog_gamengine_nav_agent__pos_bog_gamengine_demo_flat_54 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['ghost_pos'] >
		,
		ReturnType< $bog_gamengine_nav_agent['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_flat_55 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Ghost'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_flat_56 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_flat_57 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_sprite__tint_bog_gamengine_demo_flat_58 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['ghost_tint'] >
		,
		ReturnType< $bog_gamengine_sprite['tint'] >
	>
	type $bog_gamengine_demo_flat_coin__sound_bog_gamengine_demo_flat_59 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Sound'] >
		,
		ReturnType< $bog_gamengine_demo_flat_coin['sound'] >
	>
	type $bog_gamengine_demo_flat_coin__pos_bog_gamengine_demo_flat_60 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['coin_pos'] >
		,
		ReturnType< $bog_gamengine_demo_flat_coin['pos'] >
	>
	type $bog_gamengine_sprite__parent_bog_gamengine_demo_flat_61 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Coin'] >
		,
		ReturnType< $bog_gamengine_sprite['parent'] >
	>
	type $bog_gamengine_sprite__atlas_bog_gamengine_demo_flat_62 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Atlas'] >
		,
		ReturnType< $bog_gamengine_sprite['atlas'] >
	>
	type $bog_gamengine_sprite__frame_bog_gamengine_demo_flat_63 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_sprite['frame'] >
	>
	type $bog_gamengine_text_font__size_bog_gamengine_demo_flat_64 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_text_font['size'] >
	>
	type $bog_gamengine_text_font__chars_bog_gamengine_demo_flat_65 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_text_font['chars'] >
	>
	type $bog_gamengine_atlas__size_bog_gamengine_demo_flat_66 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_atlas['size'] >
	>
	type $bog_gamengine_atlas__sources_bog_gamengine_demo_flat_67 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['font_sources'] >
		,
		ReturnType< $bog_gamengine_atlas['sources'] >
	>
	type $bog_gamengine_text__font_bog_gamengine_demo_flat_68 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Font'] >
		,
		ReturnType< $bog_gamengine_text['font'] >
	>
	type $bog_gamengine_text__atlas_bog_gamengine_demo_flat_69 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['Font_atlas'] >
		,
		ReturnType< $bog_gamengine_text['atlas'] >
	>
	type $bog_gamengine_text__value_bog_gamengine_demo_flat_70 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_text['value'] >
	>
	type $bog_gamengine_text__height_bog_gamengine_demo_flat_71 = $mol_type_enforce<
		number
		,
		ReturnType< $bog_gamengine_text['height'] >
	>
	type $bog_gamengine_text__align_bog_gamengine_demo_flat_72 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_gamengine_text['align'] >
	>
	type $bog_gamengine_text__color_bog_gamengine_demo_flat_73 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['coin_text_color'] >
		,
		ReturnType< $bog_gamengine_text['color'] >
	>
	type $bog_gamengine_text__pos_bog_gamengine_demo_flat_74 = $mol_type_enforce<
		ReturnType< $bog_gamengine_demo_flat['coin_text_pos'] >
		,
		ReturnType< $bog_gamengine_text['pos'] >
	>
	export class $bog_gamengine_demo_flat extends $mol_page {
		coins_stat( ): string
		Coins( ): $mol_labeler
		screen_shown( next?: boolean ): boolean
		Screen_switch( ): $mol_check_box
		stat( ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Draw'] >['stat'] >
		draw_width( ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Draw'] >['width'] >
		draw_height( ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Draw'] >['height'] >
		draw_dpr( ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Draw'] >['dpr'] >
		pointer_down( next?: any ): any
		Draw( ): $bog_gamengine_draw
		label_left( ): string
		label_top( ): string
		Hero_label( ): $mol_view
		Screen( ): $bog_gamengine_input_screen
		Stat( ): $mol_view
		hero_stat( ): string
		Hero_stat( ): $mol_view
		ghost_stat( ): string
		Ghost_stat( ): $mol_view
		nodes_stat( ): string
		Nodes_stat( ): $mol_view
		nodes( ): readonly(any)[]
		bodies( ): readonly(any)[]
		Phys( ): $bog_gamengine_phys
		cam_pos( ): Float32Array
		palette( ): Record<string, any>
		hero_pos( next?: Float32Array ): Float32Array
		hero_face_left( next?: ReturnType< ReturnType< $bog_gamengine_demo_flat['Hero'] >['face_left'] > ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Hero'] >['face_left'] >
		hero_clip( next?: ReturnType< ReturnType< $bog_gamengine_demo_flat['Hero'] >['clip'] > ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Hero'] >['clip'] >
		ghost_pos( next?: Float32Array ): Float32Array
		ghost_tint( ): Float32Array
		coin_pos( id: any): Float32Array
		coin_taken( id: any, next?: ReturnType< ReturnType< $bog_gamengine_demo_flat['Coin'] >['taken'] > ): ReturnType< ReturnType< $bog_gamengine_demo_flat['Coin'] >['taken'] >
		font_sources( ): readonly(any)[]
		coin_text_color( ): Float32Array
		coin_text_pos( id: any): Float32Array
		title( ): string
		tools( ): readonly(any)[]
		body( ): readonly(any)[]
		foot( ): readonly(any)[]
		Input( ): $bog_gamengine_input
		Key( ): $bog_gamengine_key
		map( ): string
		Tile( ): $bog_gamengine_phys_tile
		Atlas( ): $bog_gamengine_atlas
		Point( ): $bog_gamengine_point
		Sound( ): $bog_gamengine_sound
		Clock( ): $bog_gamengine_clock
		Scene( ): $bog_gamengine_scene
		Cam( ): $bog_gamengine_cam_flat
		Tilemap( ): $bog_gamengine_tilemap
		Hero( ): $bog_gamengine_demo_flat_hero
		Hero_sprite( ): $bog_gamengine_sprite
		Grid( ): $bog_gamengine_nav_grid
		Ghost( ): $bog_gamengine_nav_agent
		Ghost_sprite( ): $bog_gamengine_sprite
		Coin( id: any): $bog_gamengine_demo_flat_coin
		Coin_sprite( id: any): $bog_gamengine_sprite
		Font( ): $bog_gamengine_text_font
		Font_atlas( ): $bog_gamengine_atlas
		Coin_text( id: any): $bog_gamengine_text
	}
	
}

//# sourceMappingURL=flat.view.tree.d.ts.map